/* global window, MATOMO_HOST, MATOMO_SITE_ID */

var oldPage = ''

export function init (t) {
  const _paq = window._paq = window._paq || []
  _paq.push(['setUserId', t.getContext().member])
  _paq.push(['enableLinkTracking'])

  var u = '//' + MATOMO_HOST + '/'
  _paq.push(['setTrackerUrl', u + 'js/'])
  _paq.push(['setSiteId', MATOMO_SITE_ID])
  var d = document
  var g = d.createElement('script')
  var s = d.getElementsByTagName('script')[0]
  g.type = 'text/javascript'
  g.async = true
  g.src = u + 'js/'
  s.parentNode.insertBefore(g, s)
}

export function setWizardProgress (id) {
  const newPage = urlWithoutHash() + '/' + id
  const _paq = window._paq
  _paq.push(['setReferrerUrl', oldPage])
  _paq.push(['setCustomUrl', newPage])
  _paq.push(['setDocumentTitle', id])
  _paq.push(['trackPageView'])
  oldPage = newPage
}

function urlWithoutHash () {
  const l = window.location
  return l.href.replace(l.hash, '')
}
